export type User = {
  id: number;
  email: string;
  displayName: string;
};

export enum PlanClassification {
  LEGACY_PLAN_CLASSIFICATION = 'Legacy',
  BASIC_PLAN_CLASSIFICATION = 'Basic',
  STARTER_PLAN_CLASSIFICATION = 'Starter',
  BUNDLE_PLAN_CLASSIFICATION = 'Bundle',
  UNLIMITED_PLAN_CLASSIFICATION = 'Unlimited',
  ENTERPRISE_PLAN_CLASSIFICATION = 'Enterprise',
  GROWTH_PLAN_CLASSIFICATION = 'Growth',
  PRO_PLAN_CLASSIFICATION = 'Pro',
}

// UserSubscription.php
export type Subscription = {
  id: number;
  uniqueId: string;
  planId: number;
  organizationId: number;
  siteId: number;
  fullName: string;
  status: string;
  subscriptionEndDate: object;
  daysLeftOnSubscription: number;
  dateAdded: string;
  dateUpdated: string;
  isStarterBundle: boolean;
  isMakerOnly: boolean;
  isUnlimitedBundle: boolean;
  isGrowthBundle: boolean;
  isPremierePro: boolean;
  planClassification: PlanClassification;
  rolloverPlanId?: number;
  monthlyDownloadsRemaining?: number;
};

export type ContentEditSegment =
  | 'unsubscribed'
  | 'subscribed_user'
  | 'upgradable_user'
  | 'enterprise_no_permission'
  | 'disabled';

/**
 * Entry point used to surface conversational search on the Prominent search
 * component. `toggle` is the current control; `button` is an alternate
 * discovery affordance.
 */
export type ConversationalSearchEntryPoint = 'toggle' | 'button';

/**
 * Parameters of the member-only conversational search discoverability experiment.
 * The two params are read from a single experiment group, so they travel together
 * as one coupled object.
 */
export interface ConversationalSearchDiscoverability {
  entryPoint: ConversationalSearchEntryPoint;
  /** Delay before auto-enabling conversational search on hover. 0 disables auto-on. */
  autoOnHoverDelayMs: number;
}

export interface AuthReducerState {
  recaptchaToken?: string;
  userFullName: string;
  makerHooksVisible?: boolean;
  projects?: [];
  isMobile?: boolean;
  monthlyDownloadsRemaining?: number;
  isLoggedIn: boolean;
  isIpAuth: boolean;
  user: User;
  subscription: Subscription;
  primarySubscription: Subscription;
  videoSubscription: Subscription;
  audioSubscription: Subscription;
  imageSubscription: Subscription;
  permissions: { [key: string]: boolean };
  featureFlags: { [key: string]: boolean };
  conversationalSearchDiscoverability?: ConversationalSearchDiscoverability;
}
